/* Impulsa3 — Receta: imprimir (section `impulsa3-recipe-print`).

   Mueve la hoja de impresión al <body> para que las reglas @media print puedan
   ocultar todo lo demás con un simple `body > *:not(...)`, y marca el <html>
   para que esas reglas solo se apliquen cuando la hoja está realmente colocada. */

const IMPULSA3_PRINT_READY_CLASS = 'impulsa3-print-sheet-ready';

class Impulsa3RecipePrint extends HTMLElement {
  connectedCallback() {
    this.sheet = this.querySelector('[data-impulsa3-print-sheet]');

    if (this.sheet) {
      document.body.appendChild(this.sheet);
      document.documentElement.classList.add(IMPULSA3_PRINT_READY_CLASS);
    }

    this.button = this.querySelector('[data-impulsa3-print-button]');
    this.button?.addEventListener('click', this.print);
  }

  disconnectedCallback() {
    // El editor del theme re-renderiza la sección entera: hay que retirar la
    // hoja vieja del <body>, que ya no cuelga de este elemento.
    this.sheet?.remove();
    this.button?.removeEventListener('click', this.print);

    if (!document.querySelector('[data-impulsa3-print-sheet]')) {
      document.documentElement.classList.remove(IMPULSA3_PRINT_READY_CLASS);
    }
  }

  print = () => {
    window.print();
  };
}

if (!customElements.get('impulsa3-recipe-print')) {
  customElements.define('impulsa3-recipe-print', Impulsa3RecipePrint);
}
